<template>
  <div class="poster-page">
    <div class="demo-bar" v-if="error">{{ error }}</div>
    <div class="demo-bar" v-else-if="loading">Loading poster…</div>
    <template v-else-if="ready">
      <dsa-poster
        ref="poster"
        :institution-name="inst"
        :subject-name="subj"
        :category="cat"
        :major="major"
        :window-label="windowLabel"
        :enrollment-close="reg"
        :exam-date="exam"
        :intro="intro"
        :registration-url="registrationUrl"
      />
      <div class="actions">
        <button type="button" class="btn btn-primary" @click="saveImage">Save as image</button>
        <a
          class="btn btn-outline"
          :href="registrationUrl"
          target="_blank"
          rel="noopener noreferrer"
        >Open registration form</a>
      </div>
    </template>
  </div>
</template>

<script>
import DsaPoster from '@/components/DsaPoster.vue'
import { getInstitutionPoster } from '@/api/dsa'
import {
  buildInstitutionRegistrationUrl,
  ensureHtml2Canvas,
} from '@/utils/institutionReg'

export default {
  name: 'PublicPoster',
  components: { DsaPoster },
  data() {
    return {
      loading: true,
      error: '',
      accountId: '',
      advisorId: '',
      projectCode: '',
      inst: '',
      subj: '',
      cat: '',
      major: '',
      exam: '',
      reg: '',
      windowLabel: '',
      intro: '',
    }
  },
  computed: {
    ready() {
      return !!(this.accountId && this.projectCode && this.subj)
    },
    registrationUrl() {
      return buildInstitutionRegistrationUrl({
        accountId: this.accountId,
        projectCode: this.projectCode,
        advisorId: this.advisorId,
      })
    },
  },
  created() {
    const q = this.$route.query || {}
    this.accountId = q.account_id || ''
    this.projectCode = q.project_code || ''
    this.advisorId = q.advisor_id || q.contact_id || ''
    this.load()
  },
  methods: {
    async load() {
      if (!this.accountId || !this.projectCode) {
        this.error = 'Missing poster parameters. Open this page from an institution Dashboard poster link.'
        this.loading = false
        return
      }
      this.loading = true
      this.error = ''
      try {
        const res = await getInstitutionPoster(this.accountId, this.projectCode, this.advisorId)
        if (!res.data || res.data.code !== 0) {
          this.error = (res.data && res.data.msg) || 'Failed to load poster'
          return
        }
        const data = res.data.data || {}
        this.inst = data.institution_name || 'Institution'
        this.subj = data.subject_name || ''
        this.cat = data.category || ''
        this.major = data.major || ''
        this.exam = data.exam_date || ''
        this.reg = data.enrollment_close || ''
        this.windowLabel = data.window_label || ''
        this.intro = data.intro || ''
        if (data.advisor_id && !this.advisorId) {
          this.advisorId = data.advisor_id
        }
        if (!this.subj) {
          this.error = 'Subject not found for this poster link.'
        }
      } catch (e) {
        this.error = 'Failed to load poster'
      } finally {
        this.loading = false
      }
    },
    async saveImage() {
      try {
        await ensureHtml2Canvas()
        const root = this.$refs.poster && this.$refs.poster.getRootEl()
        if (!root || !window.html2canvas) {
          return
        }
        const canvas = await window.html2canvas(root, { scale: 2, backgroundColor: '#fff' })
        const a = document.createElement('a')
        const slug = String(this.subj || 'subject').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase()
        a.download = `${slug}-dsa-poster.png`
        a.href = canvas.toDataURL('image/png')
        a.click()
      } catch (e) {
        /* ignore */
      }
    },
  },
}
</script>

<style scoped>
.poster-page{
  min-height:100vh;background:#eef2f7;display:flex;flex-direction:column;align-items:center;
  padding:28px 16px 48px;font-family:-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
}
.demo-bar{background:#185FA5;color:#fff;font-size:12.5px;border-radius:8px;padding:8px 16px;max-width:680px}
.actions{display:flex;gap:10px;margin-top:22px;flex-wrap:wrap;justify-content:center}
.btn{display:inline-flex;align-items:center;justify-content:center;border-radius:8px;padding:10px 16px;font-size:13.5px;font-weight:600;cursor:pointer;text-decoration:none;border:1px solid transparent}
.btn-primary{background:#185FA5;color:#fff}
.btn-outline{background:#fff;border-color:#cbd5e1;color:#185FA5}
</style>
